










































































import { Component, Vue, Prop} from "vue-property-decorator";
import { Getter ,Action} from "vuex-class";
import ActivitySection from "@/components/common/index/ActivitySection.vue";
@Component({
  components: {
    "activity-section": ActivitySection
  }
})
export default class GachaCardModal extends Vue {
  @Prop() showCardModal!: boolean; 
  @Getter('selectedCardIndex')selectedCardIndex!:number;
  @Getter("gachaTypeParameter") gachaTypeParameter!: any;
  @Getter("section") section!: object;
  @Action("changeSelectedCardIndex") changeSelectedCardIndex!: Function;
  hideModal(){
    this.$emit('hide');
  }
  cutIndex(){
    if( this.selectedCardIndex == 0){
      Vue.$toast.error('已经第一个了');
    }else{
      const index = this.selectedCardIndex -1;
      this.changeSelectedCardIndex(index)
    }
    
  }
  addIndex(){
    if(this.selectedCardIndex == (this.gachaTypeParameter.prize.proList.length -1)){
        Vue.$toast.error('已经最后一个了');
    }else{
      const index = this.selectedCardIndex + 1;  
      this.changeSelectedCardIndex(index)
    }
  
  }
}
